import React from "react";

export const SignIcon = () => {
    return (
        <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="10" cy="10" r="9.5" stroke="#EC6608" />
            <mask
                id="mask0"
                mask-type="alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="20"
                height="20"
            >
                <circle
                    cx="10"
                    cy="10"
                    r="9.5"
                    fill="#C4C4C4"
                    stroke="#EC6608"
                />
            </mask>
            <g mask="url(#mask0)">
                <path
                    d="M10 10L13 13M10 10L21 -1L24 2L13 13M10 10L9 12.5M13 13L10.5 14M8 15C3 16 5 13 -2 16M8 15L9 12.5M8 15L10.5 14M9 12.5L10.5 14"
                    stroke="#EC6608"
                />
            </g>
        </svg>
    );
};



// WEBPACK FOOTER //
// ./src/views/documentation/components/SignIcon.tsx